import Vue from "vue"
import Router from "vue-router"
import { routers } from "views/routes"
import { getItem } from "utils/defaultData"
Vue.use(Router)
const router = (routers) => {
  let router = new Router({
    mode: "history",
    routes: routers,
  })
  router.beforeEach((to, from, next) => {
    if (typeof window.entryUrl === "undefined" || window.entryUrl === "") {
      window.entryUrl = location.href.split("#")[0]
    }
    try {
      if (
        (getItem("config") != undefined) &
        (getItem("config") != "") &
        (getItem("config") != null)
      ) {
        if (
          getItem("config").name != undefined &&
          (getItem("config").name != "") & (getItem("config").name != null)
        ) {
          document.title = getItem("config").name
        }
      }
      // var u = navigator.userAgent;
      // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // // 修复iOS版微信HTML5 History兼容性问题
      // if (isiOS && to.path !== global.location.pathname) {
      //   location.assign(to.fullPath);
      // }
      next();
    } catch (err) {
      console.log("错误信息：", err)
      next()
    }
  })
  return router
}

export default router(routers)
